 import profile from "./img/defaultpic.png"
import { createUserWithEmailAndPassword, updateProfile } from "firebase/auth";
import { useState } from "react";
import  db, { auth,storage} from "./firebase";
import {  ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { Link, useNavigate } from "react-router-dom";
import { doc, setDoc } from "firebase/firestore";


const Register = () => {
     const [err,setErr] = useState();
     const[selectedImage,SetSelectedImage] = useState();
   
     const navigate = useNavigate();
   
    const handleSubmit = async (e) => {
        e.preventDefault();
        const displayName = e.target[0].value;
        const email = e.target[1].value;
        const password = e.target[2].value;
        const file = e.target[3].files[0];
     try{
      const res = await createUserWithEmailAndPassword(auth, email, password);
      const storageRef = ref(storage, 'user_profile/'+displayName);

const uploadTask = uploadBytesResumable(storageRef, file);

uploadTask.on( 

  (error) => {
    setErr(error);
  }, 
  () => {
  
    getDownloadURL(uploadTask.snapshot.ref).then(async(downloadURL) => {
       await updateProfile(res.user,{
        displayName,
        photoURL:downloadURL,
       });
       await setDoc(doc(db,"user",res.user.uid),{
        uid:res.user.uid,
        displayName,
        email,
        photoURL:downloadURL,
      
      });

     
    })
    .catch((error) =>{
    
    });
  }
 );

 const options = prompt("Login in to: 1.Chat room  2. Online Radio. Select anyone.");
   if(options === "1" || options === "Chat room"){
     navigate("/Login");
   }else if(options === "2" || options === "Online Radio"){
     navigate("/UserDetails");
   }

     }catch (err) {
       setErr(true);
     } 

    };

    return ( 
        <div className="formContainer">
            <div className="formWrapper">
                <span className="Logo">Chat Room</span>
                <span className="title">Horemow Book Reader</span>
                <form onSubmit={handleSubmit}>
                    <input type="text" placeholder="user name"/>
                    <input type="email" placeholder="email"/>
                    <input type="password" placeholder="password"/>
                    <label htmlFor="file" className="selectImage" >
                      <p>Select Profile Picture</p>  {!selectedImage && <img src={profile} alt=""/>}
                      {  selectedImage && <img src={URL.createObjectURL(selectedImage)} alt=""/> }
                    </label>
                    <input type="file" accept="image/*" id="file" style={{display: "none"}} onChange={e => SetSelectedImage(e.target.files[0])} />
                    <button>Sign up</button>
                    {err && <span>Registration failed. Contact the developer: ransadm23@gmail.com if problem persist.</span>}
                </form>
                <p>If you have account? <Link to="/Login">Click here to Login</Link> </p>
            </div>
        
        </div>
     );
}
export default Register;